import axios from "axios";

export const sendQuestionFromLandingPage = (payload) => {
  return axios
  .post(process.env.REACT_APP_FETCH_URL + "/questions-landing", payload);
} 

export const getQuestion = (questionId) => {
  return axios
  .get(process.env.REACT_APP_FETCH_URL + "/question/" + questionId);
}

export const getAnswers = (questionId) => {
  return axios
  .get(process.env.REACT_APP_FETCH_URL + "/thread/" + questionId);
}

export const sendRate = (questionId, rate) => {
  return axios
  .get(process.env.REACT_APP_FETCH_URL + "/rate-question/"+ questionId+ "/" + rate);
}

export const likeQuestion = (questionId, memberId) => {
  return axios
  .get(process.env.REACT_APP_FETCH_URL + "/support-question/"+ memberId+ "/" + questionId);
}